import { useGetList } from "ra-core";

export interface TimelineEvent {
  id: string;
  org_id: string;
  contact_id: string;
  event_type: string;
  payload: Record<string, unknown>;
  created_by: string | null;
  created_at: string;
}

export function useContactTimeline(contactId: string | undefined) {
  return useGetList<TimelineEvent>(
    "events",
    {
      pagination: { page: 1, perPage: 50 },
      sort: { field: "created_at", order: "DESC" },
      filter: contactId ? { contact_id: contactId } : {},
    },
    { enabled: !!contactId }
  );
}
